module.exports = __webpack_public_path__ + "static/980-genesis-a822edc757aee9ef563d8c96b2d80591.png";